import * as React from 'react';

import {PageContainer, PageTitleBar} from '../layout';

import {LandingPagesSettings} from './settings/landing-pages-settings';

export function LandingPagesSettingsPage() {
    return (
        <PageContainer
            title='Landing pages'
            pageTitleBar={
                <PageTitleBar
                    title='Landing pages'
                    subheaderPrimaryText='Configure your landing page visitor attribution'
                />
            }
            whiteBackground={false}
        >
            <LandingPagesSettings />
        </PageContainer>
    );
}
